import React, { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '../../fakedb/fakedb';
import './Cart.css'
import myimg from '../../image/my-bg.png';
import Swal from "sweetalert2";

const Cart = (props) => {
   
console.log(props);

    useEffect(()=>{

        const localValue = getLocalStorage();
        setValue(localValue);
    },[])
    const [value,setValue]= useState(0);
    const button =(value)=>{
    setValue( value);
    setLocalStorage(value);
    }
    let total =0;
for(const time of props.studentDetails){
    total=total+ time.time;



}

const completeActivity=()=>{

    Swal.fire("Good job!", "You complete Your Task!", "congrats");

}

    return (

        <div className='cart'>
            <div className='img'>
                <img src={myimg} alt="" />
                <div className='name'>
                     <p>Fahim Numan</p>
                     <p>from Mymensingh</p>
                </div>
                </div>
          <h2>Add A Break</h2>
          <div className='break-btn'>
            <button onClick={()=>button(20)}>20min</button>
                <button onClick={() => button(10)}>10min</button>
                <button onClick={() => button(30)}>30min</button>
                <button onClick={() => button(40)}>40min</button>
          </div>
          <div className='btn-activity'>
            <h2>Exercise Details</h2>
            <div>
                    <h2>Exercise time <span>{total}min</span></h2>
                    <h2>Break time <span>{value}min</span></h2>
            </div>
                <button onClick={() => completeActivity()}>Activity Completed</button>
            
          </div>
        </div>
    );
};

export default Cart;